import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";
import { Service_GL } from "utils/CommonFunc";
import { viewTypeState } from "recoil/contentsAtom";

function ViewToggleBtn() {
  const { t } = useTranslation();
  const [viewType, setViewType] = useRecoilState(viewTypeState);
  const [cookies, setCookie] = useCookies(["viewType"]);

  useEffect(() => {
    if (cookies.viewType === "" || cookies.viewType === undefined) {
      Service_GL ? setViewType("feed") : setViewType("list");
    } else {
      setViewType(cookies.viewType);
    }
  }, []);

  useEffect(() => {
    setCookie("viewType", viewType);
  }, [viewType]);

  const onClickFeed = () => {
    setViewType("feed");
  };

  const onClickList = () => {
    setViewType("list");
  };

  return (
    <div className="view-toggle">
      <button
        className={`btn-list ${viewType === "list" && "on"}`}
        onClick={onClickList}
        title={t("Toggle_to_Compact_Type")}
      />
      <button
        className={`btn-feed ${viewType === "feed" && "on"}`}
        onClick={onClickFeed}
        title={t("Toggle_to_Feed_Type")}
      />
    </div>
  );
}

export default ViewToggleBtn;
